import { Component, OnInit } from '@angular/core';
import { BnNgIdleService } from 'bn-ng-idle';
import { Router } from '@angular/router';
import { ConfigService } from './services/config.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit{
  title = 'mas-retail-private';
  currentPath: string;

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
    constructor(private bnIdle: BnNgIdleService, private router: Router, private config: ConfigService) {
  }
  ngOnInit(): void {
    // Load TrustArc script dynamically
    this.loadTrustArcScript();

    this.bnIdle.startWatching(1200).subscribe((res) => {
      if (res) {
        console.log('session expired');
        sessionStorage?.removeItem('loginUser');
        this.router.navigate(['/login']);
      }
    });
  }

  private loadTrustArcScript(): void {
    let trustArcUrl = environment.trustArcUrl;
    
    // Fallback: If localhost URL is detected in non-local environment, use current hostname
    if (trustArcUrl.includes('localhost.nwie.net') && !window.location.hostname.includes('localhost')) {
      const currentOrigin = window.location.origin;
      trustArcUrl = `${currentOrigin}/privacy-policy/online-privacy-policy`;
    }
    
    const script = document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = `//consent.trustarc.com/notice?domain=cm-nationwide.com&c=teconsent&js=nj&noticeType=bb&text=true&pcookie&gtm=1&cookieLink=${encodeURIComponent(trustArcUrl)}&privacypolicylink=${encodeURIComponent(trustArcUrl)}`;
    document.head.appendChild(script);
  }
}
